import store from "@/store/index";


const notifications=[]
    const firebase=null
    let endpoint=null
    let alreadyLoginNotification=false
const initialState = {
    notifications,
    endpoint,
    firebase,
    alreadyLoginNotification
}

export const notificationsStore = {
    namespaced: true,
    state: initialState,
    actions: {
        setFirebaseToken({commit}, token){
          commit("setFirebaseToken",token)
        },

        add({ commit }, notification) {
            commit("add",notification)
        },
        remove({ commit }, notification) {
            commit("remove",notification)
        },
        },

    mutations: {
        setFirebaseToken(state, token) {
        state.firebase=token;
        },
        add(state, notification){
            state.notifications.push(notification);
            setTimeout(() => {
                notification.animation=true;
                setTimeout(() => {
                    state.notifications.pop();
                    store.state.notificationsStore.alreadyLoginNotification=false;
                    },2000)

                }, 7000);
        },



    }
};